module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mach-container"
  }, [(_vm.bigImage && _vm.bigImage.length > 0) ? _c('rule-component', {
    attrs: {
      "config": {
        rules: _vm.rules
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.bigImage,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.lampFlag && _vm.lampFlag == 1) ? _c('div', {
    staticClass: "mach-marquee"
  }, [_c('div', {
    staticClass: "mach-marquee-bg"
  }, [_c('div', {
    staticClass: "text-container"
  }, [_c('div', {
    staticClass: "text marquee-animation"
  }, _vm._l((_vm.marquee), function(marquees, index) {
    return _c('span', {
      domProps: {
        "textContent": _vm._s(marquees)
      }
    })
  }))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.89rem"
    }
  }, [(_vm.bigImage && _vm.bigImage.length > 0) ? _c('div', {
    staticClass: "much-tab",
    attrs: {
      "id": "fixed-tab"
    }
  }, [_c('div', {
    staticClass: "much-tab-item",
    attrs: {
      "id": "target"
    }
  }, _vm._l((_vm.cpcTab), function(floors, index) {
    return _c('div', {
      staticClass: "item",
      class: {
        active: index == _vm.isIndex
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.changeData(index, floors)
        }
      }
    }, [_vm._v(_vm._s(floors.tab))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "much-shoplist"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-0.47rem"
    },
    attrs: {
      "id": "sliderContainer"
    }
  }, _vm._l((_vm.shopList), function(item, index) {
    return (_vm.shopList && _vm.shopList.length > 0) ? _c('div', {
      staticClass: "section",
      class: {
        more: !item.feedback
      }
    }, [(item.feedback) ? _c('div', {
      staticClass: "advertised"
    }, [_vm._v("广告")]) : _vm._e(), _vm._v(" "), (!item.feedback) ? _c('div', {
      staticClass: "no-advertised"
    }, [_vm._v("更多商户")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "data-midas": item.feedback
      },
      on: {
        "click": function($event) {
          _vm.isTurn(item.url, index)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.bigImage),
        expression: "item.bigImage"
      }],
      attrs: {
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "bottom-price"
    }, [(_vm.isShowPrice) ? _c('span', {
      staticClass: "pink"
    }, [_vm._v(_vm._s(item.price))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.shopName))])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "btn",
      class: {
        isgray: item.booked
      },
      attrs: {
        "data-midas": item.feedback
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showToast(item, index)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(item.btnText) + "\n                                    ")])])])])])])]) : _vm._e()
  }))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), _c('toast-component', {
    attrs: {
      "config": {
        toast: _vm.toast
      }
    },
    on: {
      "isbooked": _vm.getShopData
    }
  }), _vm._v(" "), (_vm.bigImage && _vm.bigImage.length > 0) ? _c('cherry-component', {
    attrs: {
      "config": {}
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-26ceca70", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26ceca70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/act/march_promotion/containers/index_page.vue
// module id = 316
// module chunks = 0